export default __webpack_public_path__ + "static/media/03.8fc95119.jpg";